import "../css/bookclosure.css";
import buttoncss from "../css/button.module.css";
import commoncss from "../css/common.module.css"
import Breadcrumb from "../components/Breadcrumb";
import {Button} from "../elements/Button";
import SearchBar from "../elements/SearchBar";
import ModuleCard from "../elements/ModuleCard";
import { ReactComponent as PlusIcon } from "../assets/icons/plus.svg";


const importPresets = () => {

    const breadcrumbItems = [
        {
          label: "Workspace name",
          link: "/myfinv2/book-closure",
          className: `${commoncss.nav_cnt_color} clickable`,
        },
        {
          label: "Book closure name",
          link: "/",
          className: `${commoncss.nav_cnt_color} clickable`,
        },
        { label: "Import from Existing Presets", link: "", className: "headerLable" },
    ];

    // const cardsData = new Array(10).fill({
    //     title: "Preset name",
    // });

    const cardsData = [{title:"Test"},{title:"BC 1"},{title:"preset 91"},{title:"Preset 30/09/2024"},{title:"new preset"},{title:"tets"},{title:"twsee"}]

    const bookClosure = () => {
        window.location.href = "/myfinv2/book-closure";
    };

    const toggleItems = [
        {label: "Templates" ,status: false,onToggle: () => {}},
        {label: "FSCP Entries" ,status: false, onToggle: () => {}},
        {label: "Assignee" ,status: false, onToggle: () => {}},
        {label: "Approver" ,status: false, onToggle: () => {}},
    ]

    return(
        <div className="import-presets-wrapper bgClr1">
            <Breadcrumb
                addCls={"bgClr1"}
                items={breadcrumbItems}
                headerActions={<></>}
            />

            <div className="bk-presets-container">
                <div className="filters-header">
                    <span className="bkcl-tb-header">Import Presets</span>

                    <SearchBar label="Search by preset name"/>
                    <Button
                        icon={<PlusIcon />}
                        btnColor={buttoncss.primary}
                        label="Import Presets"
                        onClick={bookClosure}
                    />
                </div>
                <span className="border-1px"></span>

                <div className="modulecards-grid">
                    {cardsData.map((card, index) => (
                    <ModuleCard
                        key={index}
                        title={card.title}
                        description={card.description}
                        toggles={toggleItems}
                    />
                    ))}
                </div>

            </div>
        </div>
    )

}

export default importPresets;